import React from 'react'

const GoodsReceivedNotes = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Goods Received Notes</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Receiving Goods</li>
            <li className="breadcrumb-item active">Goods Received Notes</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Goods Received Notes</h5>
                <p>Goods received notes content will be displayed here.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default GoodsReceivedNotes

